import { render, staticRenderFns } from "./download_from_api.vue?vue&type=template&id=1e2e5946"
import script from "./download_from_api.vue?vue&type=script&lang=js"
export * from "./download_from_api.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports